import { css } from '@emotion/css';
import { useController, useFormContext } from 'react-hook-form';
import { Colors } from '../../shared/styles/colors';
import { h2Style } from '../../shared/styles/text';
import { Motion, Radius, Shadow } from '../../shared/styles/tokens';

interface IEnterCodeInputProps {
  name: string;
}

export const EnterCodeInput = (props: IEnterCodeInputProps): JSX.Element => {
  const { name } = props;
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <div className={codeInputContainerStyle}>
      <input
        className={codeInputStyle}
        {...field}
        type={'text'}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        placeholder="PED-01"
        aria-label="Pedestal ID"
        aria-invalid={error ? true : undefined}
      />
    </div>
  );
};

const codeInputContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const codeInputStyle = css`
  ${h2Style}
  width: 100%;
  padding: 0.75rem 1rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border: 2px solid ${Colors.BORDER_STRONG};
  border-radius: ${Radius.md};
  color: ${Colors.CAPRI_BLUE};
  background: ${Colors.WHITE};
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  transition:
    border-color ${Motion.fast},
    box-shadow ${Motion.fast};

  &::placeholder {
    color: ${Colors.BORDER_STRONG};
    letter-spacing: 0.08em;
  }

  &:focus {
    border-color: ${Colors.CAPRI_BLUE};
    box-shadow: ${Shadow.focus};
  }
`;
